import { Component, inject } from '@angular/core';
import { ImportFlowService } from '@services/imports/import-flow.service';
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { VwbankCommissionDataSource } from '@components/new-table/data-sources/vwbank-commission.dataSource';
import { VwbankCommissionSettingsTable } from '@/table-settings/imports/vwbank-commission-settings-table';

@Component({
  selector: 'app-vwbank-commission-table',
  templateUrl: './vwbank-commission-table.component.html',
  styleUrls: ['./vwbank-commission-table.component.scss'],
})
export class VwbankCommissionTableComponent {
  displayedColumns: TableColumnsSetting<any>;

  dataSource = new VwbankCommissionDataSource(this.importFlowService);

  toastr = inject(ToastrService);
  dialog = inject(MatDialog);

  reloadTrigger$ = new Subject<any>();

  constructor(private importFlowService: ImportFlowService) {
    this.displayedColumns = VwbankCommissionSettingsTable.getColumnsSetting();
  }
}
